import { useEffect, useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  CheckCircleIcon,
  ClockIcon,
  ReceiptIcon,
  ArrowRightIcon,
} from "lucide-react";

export const PurchaseNewSuccess = () => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const dotsInterval = setInterval(() => {
      setDots((prev) => {
        if (prev.length >= 3) {
          return "";
        }
        return prev + ".";
      });
    }, 500);

    return () => clearInterval(dotsInterval);
  }, []);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container mx-auto px-4 pt-8 pb-24">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full mb-6 relative">
            <ReceiptIcon className="h-10 w-10 text-white" />
            <div className="absolute inset-0 rounded-full border-4 border-blue-200 border-t-blue-500 animate-spin"></div>
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Cupom Recebido com Sucesso!
          </h1>
          <p className="text-gray-600 text-lg mb-2">
            Validamos seu código e estamos buscando os dados da compra
          </p>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden mb-8">
          <div className="bg-gradient-to-r from-green-50 to-green-100 px-6 py-4 border-b border-gray-200">
            <h2 className="text-xl font-bold text-gray-900 flex items-center gap-3">
              <CheckCircleIcon className="h-6 w-6 text-green-600" />
              Status do Processamento
            </h2>
          </div>

          <div className="p-6">
            <div className="space-y-6">
              <div className="flex items-center gap-4 p-4 bg-green-50 rounded-lg border border-green-200">
                <div className="w-8 h-8 rounded-full bg-green-500 flex items-center justify-center">
                  <CheckCircleIcon className="h-5 w-5 text-white" />
                </div>
                <div className="flex-1">
                  <p className="font-semibold text-gray-900">
                    Cupom fiscal recebido
                  </p>
                  <p className="text-sm text-gray-600">
                    Código recebido e enviado para análise
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
                <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center">
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                </div>
                <div className="flex-1">
                  <p className="font-semibold text-gray-900">
                    Buscando dados da compra{dots}
                  </p>
                  <p className="text-sm text-gray-600">
                    Estamos lendo seu cupom fiscal para obter informações
                    detalhadas
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
                <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center">
                  <ClockIcon className="h-5 w-5 text-gray-600" />
                </div>
                <div className="flex-1">
                  <p className="font-medium text-gray-500">
                    Processamento dos produtos
                  </p>
                  <p className="text-sm text-gray-400">
                    Aguardando conclusão da etapa anterior
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <div className="bg-blue-50 rounded-lg p-6 border border-blue-200">
            <div className="flex items-center justify-center gap-3 text-blue-700 mb-3">
              <ClockIcon className="h-5 w-5" />
              <span className="font-semibold">Aguarde alguns minutos</span>
            </div>
            <p className="text-blue-600 text-sm mb-4">
              O processamento costuma levar entre 1 e 5 minutos até que
              processemos todos os dados
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                to="/dash/purchases/new"
                className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-gray-600 text-white font-medium rounded-lg hover:bg-gray-700 transition-colors"
              >
                <ReceiptIcon className="h-4 w-4" />
                Cadastrar Novo Cupom
              </Link>
              <Link
                to="/dash/purchases"
                className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
              >
                <ReceiptIcon className="h-4 w-4" />
                Ver Lista de Compras
                <ArrowRightIcon className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
